// T-WEB01-001: Neues Login — Formular-Submit + Slideshow (Slot LOGIN_SLIDESHOW).

(function () {
  // ── Login-Formular (Verhalten wie das alte buildLoginHtml) ────────────────
  var form = document.getElementById("login-form");
  var dataEl = document.getElementById("lg-data");
  var returnTo = "/";
  var loginData = {};
  try {
    loginData = JSON.parse(dataEl.textContent || "{}");
    returnTo = loginData.returnTo || "/";
  } catch {
    /* Default reicht */
  }
  var usernameInput = document.getElementById("username");
  if (usernameInput && loginData.identifier) usernameInput.value = loginData.identifier;
  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = document.getElementById("btn");
      btn.classList.add("loading");
      btn.disabled = true;
      var errBox = document.getElementById("err-box");
      errBox.innerHTML = "";
      fetch("/api/auth/login", {
        method: "POST",
        headers: { "content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          identifier: document.getElementById("username").value,
          password: document.getElementById("password").value,
          rememberMe: document.getElementById("rememberMe").checked
        })
      })
        .then(function (res) {
          if (res.ok) {
            location.href = returnTo;
            return null;
          }
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              var div = document.createElement("div");
              div.className = "lg-err";
              div.textContent = (data && data.message) || "Anmeldung fehlgeschlagen.";
              errBox.appendChild(div);
              btn.classList.remove("loading");
              btn.disabled = false;
            });
        })
        .catch(function () {
          var div = document.createElement("div");
          div.className = "lg-err";
          div.textContent = "Verbindungsfehler.";
          errBox.appendChild(div);
          btn.classList.remove("loading");
          btn.disabled = false;
        });
    });
  }

  var forgotForm = document.getElementById("forgot-form");
  var forgotOpen = document.getElementById("forgot-open");
  var forgotBack = document.getElementById("forgot-back");
  function showForgot(show) {
    if (!form || !forgotForm) return;
    form.hidden = show;
    forgotForm.hidden = !show;
    var intro = document.getElementById("login-intro");
    var loginMessage = document.getElementById("err-box");
    if (intro) intro.hidden = show;
    if (loginMessage) loginMessage.hidden = show;
    if (show) {
      var forgotIdentifier = document.getElementById("forgot-identifier");
      forgotIdentifier.value = usernameInput ? usernameInput.value : "";
      forgotIdentifier.focus();
    } else if (usernameInput) {
      usernameInput.focus();
    }
  }
  if (forgotOpen) forgotOpen.addEventListener("click", function () { showForgot(true); });
  if (forgotBack) forgotBack.addEventListener("click", function () { showForgot(false); });
  if (forgotForm) {
    forgotForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var submit = document.getElementById("forgot-submit");
      var message = document.getElementById("forgot-message");
      submit.disabled = true;
      submit.classList.add("loading");
      message.innerHTML = "";
      fetch("/api/auth/password-reset/request", {
        method: "POST",
        headers: { "content-type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ identifier: document.getElementById("forgot-identifier").value })
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) throw new Error(data.message || "Anfrage fehlgeschlagen.");
          var info = document.createElement("div");
          info.className = "lg-info";
          info.textContent = data.message || "Falls ein passendes Konto existiert, wurde eine E-Mail versandt.";
          message.appendChild(info);
          submit.classList.remove("loading");
          submit.disabled = false;
        });
      }).catch(function (error) {
        var info = document.createElement("div");
        info.className = "lg-err";
        info.textContent = error.message || "Verbindungsfehler.";
        message.appendChild(info);
        submit.classList.remove("loading");
        submit.disabled = false;
      });
    });
  }

  // ── Slideshow ─────────────────────────────────────────────────────────────
  var show = document.getElementById("lgShow");
  var cap = document.getElementById("lgCap");
  if (!show) return;
  // Nur laden, wenn die Spalte überhaupt sichtbar ist (mobil ist sie weg).
  if (!show.offsetParent && show.getClientRects().length === 0) return;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Bilder + Regler (Anzeigedauer, Zoom-Stärke) parallel laden. Die Regler
  // pflegt der Admin im Site-Backend (Schlüssel login.slideshow.*).
  Promise.all([
    fetch("/api/public/site/images?slot=LOGIN_SLIDESHOW")
      .then(function (r) {
        return r.ok ? r.json() : { items: [] };
      })
      .catch(function () {
        return { items: [] };
      }),
    fetch("/api/public/site/texts")
      .then(function (r) {
        return r.ok ? r.json() : { values: {} };
      })
      .catch(function () {
        return { values: {} };
      })
  ]).then(function (results) {
    var items = (results[0] && results[0].items) || [];
    if (!items.length) return; // Gradient-Hintergrund bleibt stehen
    var values = (results[1] && results[1].values) || {};
    var seconds = parseFloat(values["login.slideshow.seconds"]);
    if (!isFinite(seconds)) seconds = 6.5;
    seconds = Math.min(30, Math.max(2, seconds));
    var zoomPct = parseFloat(values["login.slideshow.zoom"]);
    if (!isFinite(zoomPct)) zoomPct = 6;
    zoomPct = Math.min(15, Math.max(0, zoomPct));
    show.style.setProperty("--lgZoom", String(1 + zoomPct / 100));
    show.style.setProperty("--lgZoomDur", (seconds + 0.8).toFixed(1) + "s");

    var veil = show.querySelector(".veil");
    var slides = items.map(function (it) {
      var slide = document.createElement("div");
      slide.className = "slide";
      var img = document.createElement("img");
      img.src = it.url;
      img.alt = "";
      img.draggable = false;
      slide.appendChild(img);
      show.insertBefore(slide, veil);
      return { el: slide, alt: it.altText || "" };
    });
    var idx = 0;
    function activate(i) {
      slides.forEach(function (s, j) {
        s.el.classList.toggle("on", j === i);
      });
      if (cap) cap.textContent = slides[i].alt;
    }
    activate(0);
    if (slides.length > 1 && !reduced) {
      setInterval(
        function () {
          if (document.hidden) return;
          idx = (idx + 1) % slides.length;
          activate(idx);
        },
        Math.round(seconds * 1000)
      );
    }
  });
})();
